import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {Button, DialogModal} from 'front-onceforall-core';

function ExternalInvitationSuccessView({onClose, isOpen, text}) {
  return (
    <DialogModal
      isOpen={isOpen}
      onClose={onClose}
      title={<Translate value="invitation.externalInvitationSuccessTitle"/>}
    >
      {text}
      <div className="flex-container justify-content-end mt-4">
        <Button
          type="primary"
          size="small"
          onClick={onClose}
        >
          {I18n.t('action.confirm')}
        </Button>
      </div>
    </DialogModal>
  );
}

ExternalInvitationSuccessView.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

export default ExternalInvitationSuccessView;
